<template>
  <div class="header" :class="{headerRed:headerIsRed||isScrolled}">
    <div class="headerCon minBox">
      <div class="logoInfo" @click="skipPage(1)">
        <div class="logoImg"></div>
        <div class="logoText">
          <div class="logoTitle">杭州凌浩网络科技有限公司</div>
          <div class="logoContent">不仅可以买还可以卖</div>
        </div>
      </div>
      <div class="headerNav">
        <div class="navBox">
          <div class="navItem" :class="{'active':currentPath==value.path}" @click="skipPage(value.path)" v-for="(value,key) in tabList" :key='key'>{{value.name}}</div>
        </div>
        <div class="loginBox">
          <div class="noLoginInfo" @click="toLogin()">
            <div class="loginDiv">
              <div class="loginBtn">登录</div>
            </div>
            <div class="registerDiv">
              <div class="registerBtn">注册</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "headerCom",
  data() {
    return {
      isScrolled:false,
      current:this.$route.path,
      tabList:[
        {
          path:'/',
          name:'首页'
        },
        {
          path:'/product',
          name:'产品介绍'
        },
        {
          path:'/aboutUs',
          name:'关于我们'
        }
      ]
    };
  },
  watch: {
    currentPath(newName, oldName) {
      this.currentPath=newName
    }
  },
  computed: {
    headerIsRed() {
      let path = this.$route.path;
      if (path === "/") {
        return false;
      } else {
        return true;
      }
    },
    currentPath:{
      get: function () {
       return this.$route.path
      },
      set: function (v) {
        
      }
    }
  },
  created() {},
  mounted() {
    window.onscroll = () => {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log("滚动距离" + scrollTop);
      if(scrollTop>0){
        this.isScrolled = true;
      }else{
        this.isScrolled = false;
      }
    };
  },
  methods: {
    skipPage(path) {
      this.$router.push({ path:path });
    },
    toLogin(){
      window.location.href ='https://www.51ysscw.com/system/#/login';
    }
  }
};
</script>
<style lang="scss" scoped>
$white: #fff;
$red: #a00000;
.header {
  transition: all 0.1s;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 60px;
  color: $white;
  font-family: Microsoft YaHei;
  .headerCon {
    height: 100%;
    display: flex;
    justify-content: space-between;
    .logoInfo {
      display: flex;
      align-items: center;
      .logoImg {
        width: 40px;
        height: 40px;
        background: url("~@/assets/img/logo_white.png") no-repeat;
        background-size: 100% 100%;
      }
      .logoText {
        margin-left: 10px;
        text-align: center;
        .logoTitle {
          font-size: 24px;
        }
        .logoContent {
          font-size: 14px;
          text-align: left;
        }
      }
    }
    .headerNav {
      display: flex;
      align-items: center;
      .navBox {
        display: flex;
        .navItem {
          font-size: 16px;
          margin-left: 104px;
          cursor: pointer;
          padding-bottom: 8px;
          position: relative;
          &.active{
            font-weight: bold;
            &::after{
              content:'';
              width: 26px;
              height: 2px;
              background: $white;
              position: absolute;
              bottom: 0;
              left: 50%;
              margin-left: -13px;
              border-radius: 1px;
            }
          }
        }
      }
      .loginBox {
        margin-left: 104px;
        .noLoginInfo {
          border: 1px solid $white;
          width: 108px;
          line-height: 16px;
          font-size: 14px;
          display: flex;
          text-align: center;
          border-radius: 15px;
          overflow: hidden;
          .loginDiv {
            width: 50%;
            color: $white;
            cursor: pointer;
            padding: 7px 0;
          }
          .loginBtn {
            border-right: 1px solid $white;
          }
          .registerDiv {
            width: 50%;
            cursor: pointer;
            padding: 7px 0;
          }
          .registerBtn {
          }
        }
      }
    }
  }
}
.headerRed {
  color: $red;
  background: $white;
  .headerCon {
    .logoInfo {
      .logoImg {
        background: url("~@/assets/img/logo_red.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .headerNav {
      .navItem{
        &.active{
          &::after{
            background: $red!important;
          }
        }
      }
      .loginBox {
        .noLoginInfo {
          border: 1px solid $red;
          .loginDiv {
            background: none;
            .loginBtn {
              color: $red;
              border-right: 1px solid $red;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue